import Rete from 'rete'
import Swal from 'sweetalert2'
import { nanoid } from 'nanoid/async'

import { App } from '../../App'
import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import CONST_COMPONENT from '../../const/component'

// eslint-disable-next-line
export const printMessageForDevelopmentMode = ({ message, data }) => {
  if (App.isDevMode) {
    console.log(message)
  }

  return false
}

// Set connection type once the connection has been picked
export const  getConnectionTypeOncePicked = (connection) => {
  window.XIT_FLOW_BUILDER_FLAG_COMPONENT_LIST_ACTION_CONNECTION_TYPE = connection
}

export const disableZoomForDoubleClick = ({ source }) => {
  return source !== 'dblclick'
}

export const doNotShowContextMenu = ({ node }) => {
  return !node || !App.editor.components.get(node.name).data.noContextMenu
}

export const doNotLetDeleteReferenceNode = (node) => {
  return !App.editor.components.get(node.name).data.canNotBeDeleted 
}

export const warnForIncompatibleConnection = ({ output, input }) => {
  const areSocketsCompatible = output.socket.compatibleWith(input.socket)

  if (false === areSocketsCompatible) {
    // Shows different message for "New Question/User input flow sinlge"
    if (output.socket.name === CONST_SOCKET.USER_INPUT_FLOW_SINGLE_OUTPUT) {
      Swal.fire({
        icon: 'warning',
        title: lang.utils_title_warning,
        text: lang.plugin_incompatible_connection_user_input_flow_builder
      })

      return false
    }

    Swal.fire({
      icon: 'warning',
      title: lang.utils_title_warning,
      text: lang.plugin_incompatible_connection
    })
  }

  return areSocketsCompatible
}

export const hideModalIfNodeRemoved = (node) => {
  if (Swal.isVisible()) {
    const className = 'node-id-' + node.id
    if ($('.swal2-container').hasClass(className)) {
      Swal.close()
    }
  }
}

// eslint-disable-next-line
export const changeUniqueIdOnCloneNode = async ({ node, x, y }) => {
  if (node.data.uniqueId) {
    node.data.uniqueId = await nanoid(15)
  }
}

export const deleteChildrenNodesWhenDeletingParentNode = ({ node }) => {
  if (CONST_COMPONENT.CAROUSEL === node.name || 
    CONST_COMPONENT.SEQUENCE === node.name || 
    CONST_COMPONENT.GENERIC_TEMPLATE === node.name
  ) {
    let uniqueNodes = new Set()

    const connections = node.getConnections()
    if (Array.isArray(connections) && connections.length > 0) {
      for (const connection of connections) {
        if (connection.input instanceof Rete.Input) {
          uniqueNodes.add(connection.input.node)
          const innerConnections = connection.input.node.getConnections()
          if (Array.isArray(innerConnections) && innerConnections.length > 0) {
            for (const innerConnection of innerConnections) {
              if (innerConnection.input instanceof Rete.Input) {
                uniqueNodes.add(innerConnection.input.node)
              }
            }
          }
        }
      }
    }

    let nodes = [...uniqueNodes]
    
    for (const node of nodes) {
      if (CONST_COMPONENT.CAROUSEL === node.name || 
        CONST_COMPONENT.SEQUENCE === node.name || 
        CONST_COMPONENT.GENERIC_TEMPLATE === node.name
      ) {
        // Do nothing
      } else {
        if (node instanceof Rete.Node) {
          App.editor.removeNode(node)
        }
      }
    }

    nodes = null
    uniqueNodes = null
  }

  return false
}